/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PreviewCalendarEntryDto = {
    /**
     * Date of the calendar entry
     */
    date?: string;
    /**
     * Status indicating whether games exist for this date
     */
    status?: PreviewCalendarEntryDto.status;
    /**
     * Opponent sports club logo URL (only for approved games)
     */
    logoUrl?: string;
    /**
     * Start time of the game (only for approved games with confirmed time)
     */
    startTime?: string;
};
export namespace PreviewCalendarEntryDto {
    /**
     * Status indicating whether games exist for this date
     */
    export enum status {
        PENDING_GAMES_EXIST = 'PENDING_GAMES_EXIST',
        APPROVED_GAMES_EXIST = 'APPROVED_GAMES_EXIST',
        NO_GAMES_EXIST = 'NO_GAMES_EXIST',
    }
}

